import React from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const ChannelPage = React.lazy(() => import("@mediaspace/features/category-page/CategoryPage"));
const GalleryPage = React.lazy(() => import("@mediaspace/features/category-page/GalleryPage"));

export { LinkAction } from "@mediaspace/features/category-page/actions-menu/actions-item/link-action/LinkAction";
export { ImportChannelAction } from "@mediaspace/features/category-page/actions-menu/actions-item/modal-action/import-channel/ImportChannelAction";
export { AddSubGalleryAction } from "@mediaspace/features/category-page/actions-menu/actions-item/modal-action/add-sub-gallery/AddSubGalleryAction";
export { GalleryChannels as GalleryChannelsTab } from "@mediaspace/features/category-page/channels-section/GalleryChannels";

export const renderChannelPage = getDsLayoutComponentRenderer(ChannelPage);
export const renderGalleryPage = getDsLayoutComponentRenderer(GalleryPage);
